import { useState, useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useRoutes } from "react-router-dom";
//Import from project
import { AuthContext } from "./Context/AuthContext";
import { GET_USER_LOGIN } from "./Schema/User";
import User from "./Pages/User/User";
import Login from "./Pages/Login/Login";
import Shift from "./Pages/Shift/Shift";
import GroupFee from "./Pages/GroupFee/GroupFee";
import Class from "./Pages/Class/Class";
import ClassForTeacher from "./Pages/ClassForTeacher/ClassForTeacher";
import Course from "./Pages/Course/Course";
import Layout from "./Layout/Layout";
import Subject from "./Pages/Subject/Subject";
import ExamType from "./Pages/ExamType/ExamType";
import PerformanceType from "./Pages/PerformanceType/PerformanceType";
import ExpenseType from "./Pages/ExpenseType/ExpenseType";
import Teacher from "./Pages/Teacher/Teacher";
import Student from "./Pages/Student/Student";
import Setting from "./Pages/Setting/Setting";
import Report from "./Pages/Report/Report";
import OnlineBook from "./Pages/OnlineBook/OnlineBook";
import BookContent from "./Pages/BookContent/BookContent";
import Other from "./Pages/Other/Other";
import Expense from "./Pages/Expense/Expense";
import Page404 from "./Pages/Page404/Page404";
import Invoice from "./Pages/Invoice/Invoice";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Enrollment from "./Pages/Enrollment/Enrollment";
import TeacherDetail from "./Components/Teacher/TeacherDetail";

// import TeacherDetailForTeacher from "./Components/Teacher/TeacherDetailForTeacher";
import StudyClassDetail from "./Components/StudyClass/StudyClassDetail";
import StudyClassDetailForStudent from "./Components/StudyClass/StudyClassDetailForStudent";
import StudyClassDetailForTeacher from "./Components/StudyClass/StudyClassDetailForTeacher";
import StudentEnrollment from "./Pages/StudentEnrollment/StudentEnrollment";
import { StudentDetail } from "./Components/Student/StudentDetail/StudentDetail";
import { StudentDetailInClass } from "./Components/StudyClass/Student/StudentDetail/StudentDetail";
import ExamScore from "./Components/StudyClass/Exam/ExamScore";

// import ContentCourse from "./Pages/Content/ContentCourse";
// import PackagePrice from "./Pages/PackagePrice/PackagePrice";
// import OptionPrice from "./Pages/OptionPrice/OptionPrice";
// import Lesson from "./Pages/Lesson/Lesson";
import UserAction from "./Pages/User/UserAction";

export default function Router({ prefersDarkMode, setPrefersDarkMode }) {
  const { state } = useContext(AuthContext);

  // ========================= get user login =======================
  useQuery(GET_USER_LOGIN, {
    onCompleted: ({ getUserLogin }) => {
      if (getUserLogin?.user) {
        window.localStorage.setItem("userLogin", JSON.stringify(getUserLogin));
      }
    },
    fetchPolicy: "network-only",
  });

  // ====================== check state user login ==========================
  const [token, setToken] = useState(
    JSON.parse(window.localStorage.getItem("token")),
  );

  useEffect(() => {
    async function checkUser() {
      let userToke = await JSON.parse(window.localStorage.getItem("token"));

      if (userToke) {
        setToken(userToke);
        return;
      }

      if (state?.user?.token !== null && state?.user?.token !== undefined) {
        setToken(state?.user?.token);
        window.localStorage.setItem(
          "token",
          JSON.stringify(state?.user?.token),
        );
      } else {
        setToken(null);
      }
    }

    setTimeout(() => {
      checkUser();
    }, 2000);
  }, [state?.user]);

  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));
  // console.log("userLogin::", userLogin?.user?.role);

  // console.log("userLogin?.user?.role::", userLogin?.user?.role)

  // End check Route =============================
  const LoginPage = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/login", element: <Login /> },
    { path: "*", element: <Login /> },
  ]);

  const Content = useRoutes([
    {
      path: "/",
      element: (
        <Layout
          to="/dashboard"
          prefersDarkMode={prefersDarkMode}
          setPrefersDarkMode={setPrefersDarkMode}
        />
      ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "/dashboard", element: <Dashboard /> },
        { path: "/class", element: <Class /> },
        { path: "/student", element: <Student /> },
        { path: "/teacher", element: <Teacher /> },
        { path: "/invoice", element: <Invoice /> },

        { path: "/payment", element: <Invoice /> },
        { path: "/enrollment", element: <Enrollment /> },
        { path: "/student/student-detail", element: <StudentDetail /> },
        {
          path: "/student/student-detail/student-class-detail",
          element: <StudyClassDetailForStudent />,
        },
        { path: "/teacher/teacher-detail", element: <TeacherDetail /> },
        { path: "/student/student-enrollment", element: <StudentEnrollment /> },
        {
          path: "/teacher/teacher-detail/class-detail",
          element: <StudyClassDetailForTeacher />,
        },
        { path: "/setting", element: <Setting /> },
        { path: "/setting/user", element: <User /> },
        { path: "/setting/shift", element: <Shift /> },
        { path: "/setting/group-fee", element: <GroupFee /> },
        { path: "/setting/course", element: <Course /> },
        { path: "/setting/subject", element: <Subject /> },
        { path: "/setting/exam-type", element: <ExamType /> },
        { path: "/setting/performance-type", element: <PerformanceType /> },
        { path: "/setting/expense-type", element: <ExpenseType /> },
        { path: "/setting/user-action", element: <UserAction /> },
        { path: "/setting/online-book", element: <OnlineBook /> },
        { path: "/setting/book-content", element: <BookContent /> },
        { path: "/other", element: <Other /> },
        { path: "/other/expense", element: <Expense /> },
        { path: "/other/report", element: <Report /> },
        // { path: "/other/content", element: <ContentCourse /> },
        // { path: "/other/package_price", element: <PackagePrice /> },
        // { path: "/other/option_price_name", element: <OptionPrice /> },
        // { path: "/content/lesson", element: <Lesson /> },
        {
          path: "/class/class-detail",
          element: <StudyClassDetail />,
        },
        {
          path: "/class/class-detail/student-detail",
          element: <StudentDetailInClass />,
        },
        {
          path: "/class/class-detail/exam-detail",
          element: <ExamScore />,
        },
        { path: "*", element: <Page404 /> },
      ],
    },
  ]);

  const ContentTeacher = useRoutes([
    {
      path: "/",
      element: (
        <Layout
          to="/class"
          prefersDarkMode={prefersDarkMode}
          setPrefersDarkMode={setPrefersDarkMode}
        />
      ),
      children: [
        {
          path: "/",
          element: <Navigate to={"class"} />,
        },
        {
          path: `/class`,
          element: <ClassForTeacher />,
        },
        {
          path: "/class/class-detail",
          element: <StudyClassDetail />,
        },
        {
          path: "/class/class-detail/student-detail",
          element: <StudentDetailInClass />,
        },
        {
          path: "/class/class-detail/exam-detail",
          element: <ExamScore />,
        },
        { path: "/setting", element: <Setting /> },
        { path: "/setting/online-book", element: <OnlineBook /> },
        { path: "/setting/book-content", element: <BookContent /> },
        { path: "*", element: <Page404 /> },
      ],
    },
  ]);

  if (!token) return LoginPage;
  else if (token && userLogin?.user?.role === "Teacher") return ContentTeacher;
  else return Content;
}
